export const environment = {
  firebase: {
    projectId: 'social-event-dfcb7',
    appId: '1:822976295439:web:26061fd0a12fdaacd8e97a',
    storageBucket: 'social-event-dfcb7.appspot.com',
    apiKey: 'AIzaSyD98brW5iUMiAM-zWbQLyFw5CFvklyMFtw',
    authDomain: 'social-event-dfcb7.firebaseapp.com',
    messagingSenderId: '822976295439',
    measurementId: 'G-PPXPPMKJ1F',
  },
};